import { Button, Col, Form, message, Row, Select } from "antd";
import Card from "antd/lib/card/Card";
import TextArea from "antd/lib/input/TextArea";
import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import cmaApi from "../../../../api/cmaApi";
import Loading from "../../../../components/Loading";
import TopContent from "../../../../components/TopContent";
import PageWrap from "../../../../layout/PageWrap";
import { appRoutes } from "../../../../routes/routes";
import { formItemLayoutSm } from "../../../../utils/constants";
import { messages } from "../../../../utils/messages";
import { cmaLeadStatus } from "../List";

const CmaLeadDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [sts, setSts] = useState<number | undefined>();
  const [note, setNote] = useState<string | undefined>();

  const { data, isLoading, isFetching } = useQuery(
    ["cma_leads", id],
    () => cmaApi.getLeadDetails(id),
    {
      onSuccess: (res: any) => {
        setSts(res?.data?.trangthai);
        setNote(res?.data?.note ?? "");
        queryClient.invalidateQueries("noti");
      },
    }
  );

  const mutation = useMutation(cmaApi.updateLead, {
    onSuccess: async (res: any) => {
      if (res.statusCode === 200) {
        message.success(messages.updateSuccess);
        await Promise.all([
          queryClient.invalidateQueries("cma_leads"),
          queryClient.invalidateQueries("noti"),
        ]);
        navigate(appRoutes.CMA.LEADS.LIST);
      } else message.error(res?.data?.message ?? messages.error);
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  return (
    <PageWrap
      title="CMA · Form liên hệ"
      content={
        <>
          <TopContent
            content={
              <Row>
                <Col>
                  <b>CMA · Form liên hệ</b>
                </Col>
              </Row>
            }
          />
          <div className="content">
            {isLoading || isFetching ? (
              <Loading />
            ) : (
              <Card bordered={false} className="register-form">
                <Form
                  {...formItemLayoutSm}
                  className="slider-form border_form"
                  colon={false}
                >
                  <Form.Item label="Trạng thái">
                    <Select
                      options={cmaLeadStatus.map((s) => ({
                        value: s.key,
                        label: s.value,
                      }))}
                      value={sts ?? data?.data?.trangthai}
                      onChange={(e) => setSts(e)}
                    />
                  </Form.Item>
                  <Form.Item label="Họ / Tên" className="empty">
                    <div>{data?.data?.name}</div>
                  </Form.Item>
                  <Form.Item label="Company" className="empty">
                    <div>{data?.data?.company}</div>
                  </Form.Item>
                  <Form.Item label="Điện thoại" className="empty">
                    <div>{data?.data?.phone}</div>
                  </Form.Item>
                  <Form.Item label="Email" className="empty">
                    <div>{data?.data?.email}</div>
                  </Form.Item>
                  <Form.Item label="Source" className="empty">
                    <div>{data?.data?.source}</div>
                  </Form.Item>
                  <Form.Item label="Message" className="empty">
                    <div>{data?.data?.message}</div>
                  </Form.Item>
                  <Form.Item label="Note">
                    <TextArea
                      rows={4}
                      value={note ?? data?.data?.note ?? ""}
                      onChange={(e) => setNote(e.target.value)}
                    />
                  </Form.Item>
                  <Row
                    justify="start"
                    gutter={[10, 0]}
                    style={{ marginTop: "20px" }}
                  >
                    <Col>
                      <Button
                        type="primary"
                        danger
                        onClick={() =>
                          mutation.mutate({
                            id,
                            data: {
                              trangthai: sts,
                              note,
                            },
                          })
                        }
                      >
                        Lưu
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        onClick={() => navigate(appRoutes.CMA.LEADS.LIST)}
                      >
                        Hủy
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card>
            )}
          </div>
        </>
      }
    />
  );
};

export default CmaLeadDetails;
